module.exports = __webpack_public_path__ + "static/img/exercise-7.9e01b7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/exercise-7.png
// module id = n+TK
// module chunks = 1